import { LoanFacade } from "./../loan/domain/+state/loan.facade";
import { Injectable } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import {
  OfferbundleStatus,
  LoanSigningInfo,
} from "../loan/domain/models/loan.model";
import { RenewalService } from "./renewal.service";
import { switchMap, mergeMap, tap, map } from "rxjs/operators";
import * as _ from "lodash";
import { CustomerLoanStatus, RouteHelper, parseNumber } from "common";
import { OfferBundleInfo } from "../agreement/agreement.data";

@Injectable({
  providedIn: "root",
})
export class OfferBundlesInfoResolver implements Resolve<OfferBundleInfo> {
  constructor(
    private renewalService: RenewalService,
    private loanFacade: LoanFacade
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): OfferBundleInfo | Observable<OfferBundleInfo> {
    const accountId = parseNumber(RouteHelper.getParamValueByName(route, "accountId"));
    return this.loanFacade.getSigningInfo$(accountId).pipe(
      map((loan: LoanSigningInfo) => loan),
      switchMap((loan) =>
        loan && loan.customerFacingStatus === CustomerLoanStatus.PendingRenewal
          ? this.renewalService.getOfferBundles(loan.id).pipe(
              map((offerBundles) => ({
                acceptedOfferBundle: _.find(offerBundles, {
                  // @ts-ignore - TODO: Refactor to align with "@types/lodash" typings - RYNO-12167
                  status: OfferbundleStatus.Accepted,
                }),
                loanId: loan.id,
              }))
            )
          : of(null)
      ),
      mergeMap((data: any) =>
        data?.acceptedOfferBundle
          ? this.renewalService
              .getNextOffer(data.loanId, data.acceptedOfferBundle.id)
              .pipe(
                map((nextOffer) => ({
                  offerBundleId: data.acceptedOfferBundle
                    ? data.acceptedOfferBundle.id
                    : null,
                  selectedOffer: nextOffer ? nextOffer : null,
                }))
              )
          : of(null)
      ),
      tap((result) => result)
    );
  }
}
